import { bookingClient } from './client';

export const bookingApi = {
  searchRates: (params: Record<string, unknown>) =>
    bookingClient.post('/quotes/search', params),

  getQuote: (id: string) =>
    bookingClient.get(`/quotes/${id}`),

  createBooking: (data: Record<string, unknown>) =>
    bookingClient.post('/bookings', data),

  getBookings: (params?: { page?: number; limit?: number; status?: string }) =>
    bookingClient.get('/bookings', { params }),

  getSandboxBookings: (params?: { limit?: number }) =>
    bookingClient.get('/bookings', { params: { ...params, isSandbox: true } }),

  getBooking: (id: string) =>
    bookingClient.get(`/bookings/${id}`),

  cancelBooking: (id: string, reason: string) =>
    bookingClient.put(`/bookings/${id}/cancel`, { reason }),

  uploadDocument: (bookingId: string, file: File, documentType: string) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('documentType', documentType);
    return bookingClient.post(`/bookings/${bookingId}/documents`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },

  getDocuments: (bookingId: string) =>
    bookingClient.get(`/bookings/${bookingId}/documents`),

  // Booking flow API
  createFlowBooking: (data: Record<string, unknown>) =>
    bookingClient.post('/bookings/flow', data),

  submitFlowAirline: (id: string, data: Record<string, unknown>) =>
    bookingClient.post(`/bookings/flow/${id}/airline`, data),

  submitFlowDelivery: (id: string, data: Record<string, unknown>) =>
    bookingClient.post(`/bookings/flow/${id}/delivery`, data),

  skipFlowService: (id: string, service: string) =>
    bookingClient.post(`/bookings/flow/${id}/skip/${service}`),

  getFlowPaymentSummary: (id: string) =>
    bookingClient.get(`/bookings/flow/${id}/payment-summary`),
};
